export default "__VITE_ASSET__BuSxmkt8__"